module.exports = __webpack_public_path__ + "img/missed.288fa80a.svg";